import { styled } from "theme/default/styled";

export const SActivateButtonLoader = styled.div`
  margin-bottom: 15px;
`;
